import User from './user.vue'
export default User



// WEBPACK FOOTER //
// ./src/view/main/components/user/index.js